// extracted by mini-css-extract-plugin
export default {"VoucherPage":"styles_VoucherPage__ZxmZ9","priceList":"styles_priceList__tnU7a","prompt":"styles_prompt__ZLjUx"};